import React from 'react';
import Utilities from "./classes/Utilities";
import { IAppState } from "./state/interfaces";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { BRAND_NAME } from "./AppConstants";
import { connect } from "react-redux";

interface IProps extends RouteComponentProps {
    stateCode: string | null;
}

interface IState {

}

class ApplicationError extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);

        this.state = { };
    }

    render() {
        return (
            <div>
                <div className="header">
                    <div className="header-nav">
                        <div className="text-center text-uppercase brand">
                            {BRAND_NAME}
                    </div>
                    </div>
                </div>

                <div className="error-container">
                    <div className="card">
                        <div className="card-body">
                            <div className="titleArea"><h5>Application Error!</h5></div>
                            <p className="text-uppercase">We’re experiencing a technical problem on our side, sorry about that.</p>
                            <p className="text-uppercase">Please contact our Customer Service Center and we’ll be happy to assist you with completing the purchase of your policy.</p>
                            <h5 className="text-uppercase font-weight-bold">(424) 559-5751</h5>
                            <div>&nbsp;</div>
                            <p><a href={Utilities.getHomePageUrl()} className="font-weight-bold"><i className="fas fa-chevron-left"></i> Home</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    return {
        stateCode: state.stateCode
    };
};

export default withRouter(connect(mapProps, null)(ApplicationError));

